export default __webpack_public_path__ + "static/media/fulllogo2.jpg.cc50d306.svg";